import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ciu-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.css']
})
export class MainMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/header/main-menu/main-menu.component.ts